import { useQuery } from "react-query";
import API from "../shared-utils/api";
export const getPubDetail = async (pub_id) => {
    const { data } = await API.get(`/api/v1/rbzo/pubs/customer/${pub_id}`);
    return data;
};
export const usePub = (pub_id) => {
    return useQuery(["pub", pub_id], () => getPubDetail(pub_id), {
        staleTime: 5 * 60 * 1000,
        cacheTime: 7 * 60 * 1000,
        enabled: !!pub_id,
    });
};
